module.exports = ".example-full-width {\r\n  width: 100%;\r\n}\r\n\r\n.push-down {\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.mat-hint {\r\n  color: red;\r\n}\r\n"